import { drawErrorScene } from '@/gui/error-scene.js';

/**
 * Scena di errore mostrata quando si verifica un errore di rete o del server
 * @extends Phaser.Scene
 */
export default class ErrorScene extends Phaser.Scene {
	constructor() {
		super({ key: 'ErrorScene' });
		this.errorMessage = '';
		this.retryCallback = null;
	}

	/**
	 * Inizializza la scena con dati personalizzati
	 * @param {Object} data - Dati passati alla scena
	 * @param {string} data.message - Messaggio di errore da mostrare
	 * @param {Function} data.onRetry - Callback da eseguire quando si clicca RIPROVA
	 */
	init(data) {
		this.errorMessage = data.message || 'Si è verificato un errore imprevisto';
		this.retryCallback = data.onRetry || null;
	}

	create() {
		console.log('ErrorScene created with message:', this.errorMessage);

		// Disegna la scena di errore
		const { buttonRetry, buttonQuit } = drawErrorScene(this, this.errorMessage);

		// Handler bottone RIPROVA
		buttonRetry.on('pointerdown', () => {
			console.log('Bottone RIPROVA cliccato');

			// Se c'è un callback personalizzato, eseguilo
			if (this.retryCallback && typeof this.retryCallback === 'function') {
				this.retryCallback();
			} else {
				// Comportamento di default: riavvia Boot per rifare la chiamata
				this.scene.start('Boot');
			}
		});

		// Handler bottone ESCI
		buttonQuit.on('pointerdown', () => {
			console.log('Bottone ESCI cliccato');

			// Torna al menu principale
			// NON usare SplashScreen perché ri-avvia Boot automaticamente causando un loop
			this.scene.stop('Boot');
			this.scene.stop('Game');
			this.scene.start('MainMenu');
		});
	}
}